import React from 'react'
import { Field, FieldArray } from 'redux-form'
import { vRequired } from 'components/Input/Input.validations'
import SelectPretty from 'components/Input/SelectPretty'
import { Input } from 'components/Input/Input'
import { pick, values } from 'lodash'
import FieldArrayRows from 'components/Input/FieldArrayRows'

const possibleOperators = {
  is: {
    name: 'is',
    value: 'is',
  },
  contains: {
    name: 'contains',
    value: 'contains',
  },
  regex: {
    name: 'matches regex',
    value: 'regex',
  },
  anyOf: {
    name: 'any of',
    value: 'anyOf',
  },
  lessThan: {
    name: 'less than',
    value: 'lessThan',
  },
  greaterThan: {
    name: 'greater than',
    value: 'greaterThan',
  },
  between: {
    name: 'between',
    value: 'between',
  },
}

const arrayOperators = ['anyOf', 'between']

const ArrayValueField = props => (
  <Field
    component={props.childComponent || Input}
    label="Value"
    validate={[vRequired]}
    {...props}
  />
)

const ValueField = ({ formData: { operator }, component, ...otherProps }) => {
  if (operator === 'between') {
    return (
      <div>
        <Field
          name="value.0"
          label="From value"
          component={component || Input}
          validate={[vRequired]}
          {...otherProps}
        />
        <Field
          name="value.1"
          label="To value"
          component={component || Input}
          validate={[vRequired]}
          {...otherProps}
        />
      </div>
    )
  } else if (operator === 'anyOf') {
    return (
      <FieldArray
        name="value"
        FieldComponent={ArrayValueField}
        childComponent={component || Input}
        component={FieldArrayRows}
        {...otherProps}
      />
    )
  }
  return (
    <Field
      name="value"
      label="Value"
      component={component || Input}
      validate={[vRequired]}
      {...otherProps}
    />
  )
}

export default props => {
  const {
    operators,
    formData: { value },
    change,
    ...otherProps
  } = props
  const updateValue = newOperator => {
    const newIsArray = arrayOperators.includes(newOperator)

    if (!Array.isArray(value) && newIsArray) {
      // If we are moving from single -> array
      change('value', [value, undefined])
    } else if (Array.isArray(value) && !newIsArray) {
      // If we are moving from array -> single
      change('value', value[0])
    }
  }

  return (
    <div>
      <Field
        name="operator"
        label="Operator"
        component={SelectPretty}
        onChangeAlt={updateValue}
        options={values(pick(possibleOperators, operators))}
        validate={[vRequired]}
      />
      <ValueField formData={props.formData} {...otherProps} />
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/features/Flows/Flow/Nodes/components/OperatorField/OperatorField.jsx